import { EntrataSession, ViewerSessionOrigin } from 'auth/EntrataSession';
import { BASE_URL } from 'config/api/URL';

export type JourneyNavigationSource = 'url' | 'step_change' | 'tab_change';

export type JourneyVisitAction = 'enter' | 'leave';

export interface ApplicantJourneyPageVisitPayload {
  sessionOrigin: ViewerSessionOrigin;
  responseId: string;
  applicationId: string;
  orgId: number;
  propertyId: number;
  pageId: string;
  pageType?: string;
  pageName?: string;
  action: JourneyVisitAction;
  routePath: string;
  companyUserId?: number | null;
  companyUserDisplayName?: string | null;
  navigationSource: JourneyNavigationSource;
  visitedAt: string;
}

export function isJourneyTrackingApiEnabled(): boolean {
  const envValue =
    process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test'
      ? process.env.VIEWER_JOURNEY_TRACKING_ENABLED
      : (window as any).env?.VIEWER_JOURNEY_TRACKING_ENABLED;

  return envValue !== 'false';
}

export function trackApplicantJourneyPageVisit(payload: ApplicantJourneyPageVisitPayload): void {
  const { applicant } = EntrataSession;
  const { sid } = applicant ?? {};
  if (!sid || !isJourneyTrackingApiEnabled()) {
    return;
  }

  const url = `${BASE_URL}/viewer/journey/page-visits`;
  const body = JSON.stringify(payload);

  fetch(url, {
    method: 'POST',
    credentials: 'include',
    keepalive: true,
    headers: {
      'content-type': 'application/json',
      'x-form-viewer-id': sid,
    },
    body,
  }).catch(() => {
    // Fire-and-forget: journey tracking must not interrupt the applicant flow.
  });
}
